<template>
  <w-flex wrap>
    <div class="xs12 headline text-left pl7 pa1">Address Coverage</div>
    <w-divider class="my6 mx-3"></w-divider>
  </w-flex>
  <!-- <w-flex> -->
    <!-- TODO ADD switch system for better interaction
    <w-radios
    v-model="insertType"
    :items="insertTypes">
  </w-radios> -->
  <w-form
    @submit.prevent="valid ? checkLocation() : null"
    v-model="valid"
    class="mx5"
  >
    <w-input
      label="Address"
      v-model.trim="addressQuery"
      :validators="[validators.required]"
      :loading="loadingIcon"
      aria-autocomplete="list"
      list="results"
      @keyup="delayedSearch($event.target.value)"
    >
    </w-input>
    <datalist id="results">
      <option
        v-for="(item, index) in results"
        :key="index"
        :value="item.fullAddress"
        @click="selectAdd(item)"
      >
        {{ item.fullAddress }}
      </option>
    </datalist>

    <w-flex justify-space-between gap="3">
      <!-- use coordinates checkuot auto sync form address with coordinates  -->
      <w-input
        label="latitude"
        name="latitude"
        v-model="coordinates.latitude"
        :validators="[validators.notNull]"
        :loading="loadingIcon"
        @keyup="
          delayedRSearch({
            lat: $event.target.value,
            lng: coordinates.longitude,
          })
        "
      >
      </w-input>
      <w-input
        label="longitude"
        name="longitude"
        v-model="coordinates.longitude"
        :validators="[validators.notNull]"
        :loading="loadingIcon"
        @keyup="
          delayedRSearch({
            lat: coordinates.latitude,
            lng: $event.target.value,
          })
        "
      >
      </w-input>
    </w-flex>
    <w-button
      class="my5"
      type="submit"
      :disabled="!valid ||( coordinates.longitude==0 &&coordinates.latitude==0)"
      >Start Check</w-button
    >
  </w-form>
 
<!-- </w-flex> -->
  <w-card
    class="coverage-result mx5"
    :class="output.style"
    v-if="output.display"
  >
    <div class="coverage-result__inner">
      <div class="coverage-result__icon">
        <w-icon xl>{{ output.icon }}</w-icon>
      </div>
      <div class="coverage-result__body">
        <div class="coverage-result__title">{{ output.message }}</div>
        <div class="coverage-result__sub">{{ output.subtitle }}</div>
      </div>
    </div>
  </w-card>
</template>

<script>
import { addressStore } from "../store/address";
import { reactive, ref, onMounted } from "vue";
import CoverageService from "../CoverageService";

export default {
  name: "CoverageView",
  setup: () => {
    const loadingIcon = ref(false);
    let coordinates = ref({ latitude: 0, longitude: 0 });
    let addressQuery = ref("");
    let address = ref({
      country: "",
      route: "",
      streetNumber: "",
      postalCode: "",
      city: "",
      area: "",
    });
    const results = reactive([]);
    let output = ref({
      display: false,
      style: "",
      message: "",
      subtitle: "",
      icon: "",
    });
    const valid = ref(null);
    let form = reactive({
      coordinates: coordinates.value,
      address: address.value,
    });
    function checkLocation() {
      output.value.display = false;
      CoverageService.coverage(coordinates.value).then(({ data }) => {
        if (data.antennas.length > 0) {
          let antennas = data.antennas.filter((a) => a.inRange);
          console.log(antennas);
          if (antennas.some((a) => a.status === "active" || a.status === "assumedIdle")) {
            output.value = {
              display: true,
              style: "success",
              message: "Location is covered",
              subtitle: "The area is covered and the service is active.",
              icon: "mdi mdi-check",
            };
          } else if (antennas.length > 0) {
            output.value = {
              display: true,
              style: "warning",
              message: "Location coverage not active",
              subtitle: "The area is reached but no station is currently operational.",
              icon: "mdi mdi-alert",
            };
          } else {
            output.value = {
              display: true,
              style: "error",
              message: "Location not covered",
              subtitle: "No coverage available for this location.",
              icon: "mdi mdi-close",
            };
          }
        } else {
          output.value = {
            display: true,
            style: "error",
            message: "Location not covered",
            subtitle: "No coverage available for this location.",
            icon: "mdi mdi-close",
          };
        }
      });
    }
    let selectAddress = ref({});
    const delayed = reactive({
      timer: 0,
      function: null,
      ms: 500,
    });
    function selectAdd(item) {
      console.log(item);
      selectAddress = item.address;
      addressQuery = item.fullAddress;
      coordinates.value.latitude = item.coordinates.lat;
      coordinates.value.longitude = item.coordinates.lng;
    }
    // set daley as global
    // set possibilito to set a function as delayable
    // set setting of delayer
    // even if multiple event is triggred the const is updated son the delayed delayablebl is not repeted until the timeout is cleared
    function delay(...args) {
      // console.log("delay");
      delayed.timer = setTimeout(delayed.function.bind(...args), delayed.ms);
    }
    function delayedSearch(target) {
      output.value.display=false
      clearTimeout(delayed.timer);
      // v4 takes the address as a path segment: an empty/too short query would produce
      // /v4/geocode/address/ and 404
      if (!target || target.trim().length < 3) {
        results.splice(0);
        loadingIcon.value = false;
        return;
      }
      // console.log("trigger");
      delayed.timer = 0;
      delayed.function = function () {
        search(target);
      };
      delayed.ms = 800;
      clearTimeout(delayed.timer);
      delay(target);
    }
    async function search(e) {
      loadingIcon.value = true;  
      coordinates.value.latitude = 0;
      coordinates.value.longitude = 0;
      console.log("search");
      results.splice(0);
      await addressStore.getGeocoding(e).then((response) => {
        console.log(response);
        response.forEach((ad) => {
          if (ad.formattedAddress && ad.location) {
            results.push({
              fullAddress: ad.formattedAddress,
              address: ad,
              coordinates: {
                lat: ad.location.latitude,
                lng: ad.location.longitude,
              },
            });
          }
        });
        if (response.length == 1) {
          let item = response[0];
          addressQuery.value = item.formattedAddress;
          coordinates.value.latitude = item.location.latitude;
          coordinates.value.longitude = item.location.longitude;
        }
        loadingIcon.value = false;
      });
    }
    function delayedRSearch(target) {
      output.value.display=false
      addressQuery.value=""
      clearTimeout(delayed.timer);
      // console.log("trigger");
      delayed.timer = 0;
      delayed.function = async function () {
       await searchReverse(target.lat, target.lng);
      };
      delayed.ms = 800;
      clearTimeout(delayed.timer);
      delay(target);
    }
    async function searchReverse(lat, lng) {
      console.log(lat, lng);
      await addressStore.reverseGeocoding(lat, lng).then((response) => {
        console.log("searchReverse function",response);
        response.forEach((ad) => {
          if (ad.formattedAddress && ad.location) {
            results.push({
              fullAddress: ad.formattedAddress,
              address: ad,
              coordinates: {
                lat: ad.location.latitude,
                lng: ad.location.longitude,
              },
            });
          }
        });
        if (results.length > 0 && response.length > 0) {
          addressQuery.value = response[0].formattedAddress;
        }

        loadingIcon.value = false;
      }).catch(()=>loadingIcon.value = false);
    }
    function getCurrentLocation() {
      loadingIcon.value = true;
      return new Promise((resolve, reject) => {
        navigator.geolocation.watchPosition(
          (pos) => {
            form.coordinates.latitude = pos.coords.latitude;
            form.coordinates.longitude = pos.coords.longitude;
            //DO geocodig to get address and update form
            loadingIcon.value = false;
            resolve(pos);
          },
          (err) => {
            window.alert(
              "Geolocalizzazione non disponibile. Controllare privacy del browser."
            );
            loadingIcon.value = false;
            reject(err);
          }
        );
      });
    }
    //DO get browser location on MOUNT
    onMounted(() => {
      // getCurrentLocation();
    });
    //DO watch coordinates when completed update

    return {
      coordinates,
      address,
      form,
      valid,
      loadingIcon,
      validators: {
        required: (value) => !!value || "This field is required",
        notNull: (value) =>
          (value != null &&value != undefined&&(value instanceof String? value.trim()!="":value!="")) || "This field is required",
        notZero: (value)=> (value!=0) || "A valid value is required",
      },
      addressQuery,
      output,
      addressStore,
      selectAddress,
      delayedSearch,
      delayedRSearch,
      getCurrentLocation,
      checkLocation,
      selectAdd,
      results,
    };
  },
};
</script>

<style scoped>
.coverage-result {
  margin-top: 16px;
  border-radius: 8px !important;
  border: 1px solid !important;
  box-shadow: none !important;
}

.coverage-result__inner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.coverage-result__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.coverage-result__body {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.coverage-result__title {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
}

.coverage-result__sub {
  font-size: 11px;
  line-height: 1.4;
  opacity: 0.85;
}

/* success */
.coverage-result.success {
  background: #f1f8e9 !important;
  border-color: #aed581 !important;
}
.coverage-result.success .coverage-result__icon {
  background: #c5e1a5;
  color: #33691e;
}
.coverage-result.success .coverage-result__title { color: #33691e; }
.coverage-result.success .coverage-result__sub   { color: #558b2f; }

/* warning */
.coverage-result.warning {
  background: #fff3e0 !important;
  border-color: #ffcc80 !important;
}
.coverage-result.warning .coverage-result__icon {
  background: #ffe0b2;
  color: #e65100;
}
.coverage-result.warning .coverage-result__title { color: #e65100; }
.coverage-result.warning .coverage-result__sub   { color: #bf360c; }

/* error */
.coverage-result.error {
  background: #ffebee !important;
  border-color: #ef9a9a !important;
}
.coverage-result.error .coverage-result__icon {
  background: #ffcdd2;
  color: #b71c1c;
}
.coverage-result.error .coverage-result__title { color: #c62828; }
.coverage-result.error .coverage-result__sub   { color: #c62828; }
</style>
